// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "channels";
require("jquery");

require("@nathanvda/cocoon")
import "./common";
import "./datePickr";

//= require popper
//= require bootstrap-sprockets
//= require activestorage
//= require turbolinks
//= require_tree .

Rails.start();
Turbolinks.start();
ActiveStorage.start();

$(document).on("turbolinks:load", () => {
  $('[data-transition="js"]').on("click", function(){
    var url = $(this).attr("href");
    var target = $(this).attr("target");
    if(target == "_blank") {
      window.open(url, '_blank');
    } else {
      window.location = url;
    }
  });

  $(".tr-link").on("click", function (e) {
    window.location = $(this).attr("href");
  });
  $(".url-in-link").on("click", function(event) { //  引数にeventを追加
    event.stopPropagation()
  });
});
